import { alpha } from '@mui/material/styles';
import { get } from 'lodash';

/**
 * Tạo keyframes động dựa trên màu sắc.
 * @param {string} color - Tên màu từ theme (info, success, error, etc.).
 * @param {object} border - Độ rộng của shadow bốn phía (top, right, bottom, left).
 * @param {number} alphaVal - Độ trong suốt của shadow.
 * @returns {object} Keyframes cho hiệu ứng động.
 */
const createPulseEffect = (color, border, alphaVal) => ({
  '0%': { boxShadow: 'none' },
  '100%': {
    boxShadow: (theme) => {
      const mappedColor = get(theme.palette, `${color}.main`, color); // Lấy màu từ theme
      return `${border.top}px ${border.right}px ${border.bottom}px ${border.left}px ${alpha(mappedColor, alphaVal)}`;
    }
  }
});

/**
 * Trả về các style cần dùng cho hiệu ứng dựa vào status.
 * @param {object} config - Cấu hình animation.
 * @param {string} config.color - Tên trạng thái (success, error, info, etc.).
 * @param {object} config.border - Độ rộng của shadow bốn phía.
 * @param {number} config.alphaVal - Độ trong suốt của shadow.
 * @param {string} config.key - Keyframes name.
 * @returns {object|null} Các style được cấu hình sẵn hoặc null nếu không có color.
 */
const useRealtimeStyles = (config = {}) => {
  const { border = {}, ...configSetting } = config;
  const settings = {
    key: '',
    color: false,
    alphaVal: 0.18,
    border: { top: 0, right: 0, bottom: 0, left: 8, ...border },
    ...configSetting
  };

  if (!settings.color) return null;

  return {
    animation: `effect_active_realtime__${settings.key} ease 1000ms infinite`,
    [`@keyframes effect_active_realtime__${settings.key}`]: createPulseEffect(settings.color, settings.border, settings.alphaVal)
  };
};

export { createPulseEffect, useRealtimeStyles };
